import { OpportunityHeadRate, OpportunityHeadStatusCode } from '../apiClient/client';

export class OpportunitiesObject {
    city: string | undefined;
    company: string | undefined;
    createdDate: Date | undefined;
    email: string | undefined;
    phonenumber: string | undefined;
    name: string | undefined;
    state: string | undefined;
    topic: string | undefined;
    opportunityid: string | undefined;
    descripton: string | undefined;
    rate: OpportunityHeadRate | undefined;
    statusCode: OpportunityHeadStatusCode | undefined;
    industry: string | undefined;

    constructor(
        city: string | undefined,
        company: string | undefined,
        createdDate: Date | undefined,
        email: string | undefined,
        phonenuber: string | undefined,
        name: string | undefined,
        state: string | undefined,
        topic: string | undefined,
        opportunityid: string | undefined,
        description: string | undefined,
        rate: OpportunityHeadRate | undefined,
        statusCode: OpportunityHeadStatusCode | undefined,
        industry: string | undefined
    ) {
        this.city = city;
        this.company = company;
        this.createdDate = createdDate;
        this.email = email;
        this.phonenumber = phonenuber;
        this.name = name;
        this.state = state;
        this.topic = topic;
        this.opportunityid = opportunityid;
        this.descripton = description;
        this.rate = rate;
        this.statusCode = statusCode;
        this.industry = industry;
    }
}

export class ApiOpportunitiesState {
    opportunities: OpportunitiesObject[];
    loading: boolean;
}



// WEBPACK FOOTER //
// ./src/data/opportuneties/opportunetisModels.ts